import { DataTableCol } from "../../../../../components/data-table/types";

export const ONDCOrdersDataGridCols: DataTableCol[] = [
    {
        title: 'Date',
        control: 'created_dt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'BAP',
        control: 'bap_app',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Order ID',
        control: 'order_id',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Amount',
        control: 'amount',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Details',
        control: 'details',
        sortable: true,
        canShowColumn: true
    },
];